<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useConnectionStore } from '@/stores/connectionStore'

// Components
import MetaUpdater from '../MetaUpdater.vue'
import Step2Loading from '../components/Loading/Step2Loading.vue'

const showStep2 = ref(false)
const connectionStore = useConnectionStore()
const router = useRouter()

const startLoading = () => {
  // Show loading bar, then go straight to desktop
  showStep2.value = true
  setTimeout(() => {
    router.push('/office')
  }, 8000)
}

onMounted(() => {
  if (connectionStore.status === 'restart') {
    startLoading()
  } else {
    router.push('/office')
  }
})
</script>

<template>
  <MetaUpdater />
  <div>
    <Step2Loading v-if="showStep2" />
  </div>
</template>
